module.exports = __webpack_public_path__ + "img/accountperson.8af50ef6.png";